import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@mui/material'
import { PDF_MIME_TYPE } from 'constants/docUploadConstant'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-regular-svg-icons'
import EditNewIcon from 'images/editNewIcon'
import { MESSAGES } from '../messages/messages'

const ImagePreviewActions = ({ mimeType, handleEdit = () => {}, handleDelete = () => {} }) => {
    return (
        <Box
            data-testid={`driver_action_block`}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: mimeType !== PDF_MIME_TYPE ? 'space-between' : 'center',
                width: '100%'
            }}
        >
            {mimeType !== PDF_MIME_TYPE && (
                <Button
                    variant="text"
                    data-testid="edit"
                    disableRipple
                    startIcon={<EditNewIcon />}
                    onClick={handleEdit}
                    sx={{
                        '.MuiButton-startIcon': {
                            width: '24px',
                            height: '24px'
                        }
                    }}
                >
                    <Typography
                        sx={{
                            typography: 'boldBody2',
                            color: 'common.link.light'
                        }}
                    >
                        {MESSAGES.edit}
                    </Typography>
                </Button>
            )}
            <Button
                variant="text"
                data-testid="delete"
                disableRipple
                startIcon={<FontAwesomeIcon icon={faTrashCan} />}
                onClick={handleDelete}
            >
                <Typography
                    sx={{
                        typography: 'boldBody2',
                        color: 'common.link.light'
                    }}
                >
                    {MESSAGES.delete}
                </Typography>
            </Button>
        </Box>
    )
}

ImagePreviewActions.propTypes = {
    mimeType: PropTypes.string,
    handleEdit: PropTypes.func,
    handleDelete: PropTypes.func
}

export default ImagePreviewActions
